import { RefreshTokenResponse } from './../../auths-api/refresh-token';

export const mockRefreshTokenResponse: RefreshTokenResponse = {
  access_token_expiration: '2023-10-05T01:31:10.861050+09:00',
  refresh_token_expiration: '2023-10-05T01:31:10.861050+09:00',
};
